"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const Button_1 = require("../../../components/button/Button");
const __1 = require("../../../../");
const autosave_1 = require("../../../../hooks/autosave");
const validation_1 = require("../../../../hooks/validation");
const viewstate_1 = require("../../../../entities/viewstate");
const TaskPage_1 = require("../../base/TaskPage");
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const FormInput_1 = require("../../../components/input/text/FormInput");
const constants_1 = require("../../../../tasks/constants");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Heading_1 = require("../../../components/heading/Heading");
const Label_1 = require("../../../components/input/label/Label");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const restrictedContent_1 = require("../../../../util/restrictedContent");
exports.default = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { getState } = (0, react_redux_1.useStore)();
    // @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
    const { entityActions } = React.useContext(__1.AppContext);
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [valid, errMsg] = (0, validation_1.usePropertyValidation)('name', property);
    const [shell, setShell] = React.useState(viewstate_1.ViewState.IDLE);
    const generate = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.stopPropagation();
        if (!property)
            return;
        if (shell === viewstate_1.ViewState.LOADING)
            return;
        setShell(viewstate_1.ViewState.LOADING);
        yield dispatch(entityActions.propertyShell.create({
            bedroom_number: new Set(property.beds.filter((b) => b.bedroom !== null)).size,
            extra_bed_number: property.property_type === 'studio' ? new Set(property.beds.filter((b) => b.bedroom === null)).size : 0,
            city: property.city,
            latitude: property.latitude,
            longitude: property.longitude,
            property_type: property.property_type
        }));
        const data = getState().data.propertyShell;
        setShell(viewstate_1.ViewState.IDLE);
        if (data) {
            update({ name: data.name });
        }
    });
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.LISTING_HEADLINE, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Heading_1.HeadingSmall, null,
                        React.createElement(Label_1.Label, { htmlFor: "property-name-input" }, "Property title")),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Paragraph_1.Paragraph, { fillParent: "mid" }, "The Property title is what guests see when they search for a place to stay. Use it to showcase your property."),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'headline-info', text: "We can generate a listing headline based on market insight which will help make your property stand out to guests." }),
                    React.createElement(Button_1.Button, { loading: shell === viewstate_1.ViewState.LOADING, onClick: generate }, "Generate new title"),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(FormInput_1.FormInput, { id: "property-name-input", value: property === null || property === void 0 ? void 0 : property.name, onChange: (e) => update({ name: e.target.value }), minLength: 20, maxLength: 50, valid: valid, errorMessage: errMsg }),
                    React.createElement(Spacer_1.Spacer, null),
                    (0, restrictedContent_1.hasCapitalWords)(property === null || property === void 0 ? void 0 : property.name) ? React.createElement(merlin_info_panels_1.DidYouKnow, { id: 'description-help', colour: { background: '#FFF0EC', text: 'rgba(17,34,58,0.650)' }, text: "Remove words using all capitals to allow publishing on channels like Airbnb" }) : '')))));
};
//# sourceMappingURL=TitlePage.js.map